export default function (anchor) {

    if (anchor) {
        window.scrollTo(0, anchor.getBoundingClientRect().top + window.scrollY - 80);

        let container = anchor.closest('.comment');
        if (container) {
            container.classList.add('target');

            setTimeout(() => {
                container.classList.remove('target');
            }, 2000);
        }
    }
}